import { buildComponent } from '#components'

export const ContactForm = buildComponent({
  name: 'contact-form',
  onConnected: (component) => {
    const formEl = component.querySelector('.js-contact-form') as HTMLFormElement

    if (formEl) {
      formEl.addEventListener('submit', async () => {
        formEl.classList.add('_submitting')
        document.body.classList.add('contact-form-submitting')
      })

      const url = new URL(window.location.href)
      const isSuccess =
        url.searchParams.has('contact_posted') || document.body.classList.contains('contact-form-submitted')

      if (isSuccess) {
        formEl.classList.add('_successful')
        document.body.classList.add('contact-form-submitted')

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'contact-form': typeof ContactForm
  }
}
